import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=08bf8935&scoped=true"
import script from "./ticketDetail.vue?vue&type=script&lang=js"
export * from "./ticketDetail.vue?vue&type=script&lang=js"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=08bf8935&prod&lang=scss&scoped=true"
import style1 from "./ticketDetail.vue?vue&type=style&index=1&id=08bf8935&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf8935",
  null
  
)

export default component.exports